<script>
    import ButtonRounded from "../../common/ButtonRounded.svelte"
    import Icon from '../../components/Icon.svelte';
    import { useNavigate } from 'svelte-navigator';
    import authStore from 'store/auth';
    import { v4 as uuidv4 } from 'uuid';
    import widgetStore from 'store/widget';
    import { connect, initiateCall } from "domain/call/telephony.actions";
    import pubsub from 'sweet-pubsub';
    import generateKeyPair, { decryptData } from 'services/encryption_keys';
    import { getLiveReceiver } from "../../domain/session/receivers.actions";
    import call from "../../store/call";
    import { onMount } from "svelte";
  import { fade } from "svelte/transition";

    const navigate = useNavigate();
    let disabled = false
    let contact = {
        name: "",
        mobile: "",
    }
    let event = ""
    let errors = {}
    let stages = [
        "start",
        "connect",
        "enter-name",
        "thank-you",
        "enter-email"
    ]
    let stage = 0

    // const chat = async type => {
    //     errors = {
    //         email: !contact.email || (contact.email && !isValidEmail(contact.email)) ? "email is required" : null
    //     }
    //     if (Object.values(errors).some(v => v && v !== null)) {return false}
    //     const data = {
    //         ...contact,
    //         id: $authStore.user.id || `@${uuidv4()}@${contact.email.replace(/[^a-z0-9]/gi, '')}`
    //     }
    //     authStore.setUser(data);
    //     navigate(`/${type}`, {replace: true})
    // };

    const isValidPhone = phone => {
        const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/, "gm");
        return phoneRegex.test(phone);
    }

    const initCall = () => {
        stage = 1;
        event = "loading";
        setTimeout(() => {
            stage = 2;
            event = ""
        }, 2000);
    }

    const processName = async () => {
        if (!contact.name) {
            errors.name = "Full name is required";
            return
        }
        const splitted_names = contact.name.split(" ")

        const data = {
            ...$authStore.user,
            first_name: splitted_names[0],
            last_name: splitted_names.length > 1 ? splitted_names[1] : "",
            ...contact,
            id: $authStore.user.id || `@${uuidv4()}@${contact.name.replace(/[^a-z0-9]/gi, '')}`
        }

        authStore.setUser(data);
        stage = 3;
        event = "loading";

        try {
            await connect();
            stage = 4;
            event = "ringing"
        } catch (error) {
            errors.message = "Cannot connect to business, please check your internet"
            reset()
        }
        
    }

    const reset = () => {
        stage = 0;
        event = "";
        disabled = false
        setTimeout(() => {
            errors = {}
        }, 5000)
    }

    const processPhone = async () => {
        if ( contact.mobile && !isValidPhone(contact.mobile)) {
            errors.mobile = "Phone is invalid";
            return
        }

        authStore.setMobile(contact.mobile);
        
        try {
            disabled = true
            // await connect();
            const phone = $widgetStore.business_number;
            setTimeout(() => {
                initiateCall(phone, {})
            }, 1000);
        } catch (e) {
            console.dir(e)
            // navigate to 
            stage = 0;
            event = ""
            navigate("/message", {replace: true})
        }
    }

    const handleChange = (e) => {
        const input = e.target.value;
        input.replace(/[^A-Za-z\s]/g, '');
  };

    onMount(() => {
        generateKeyPair().then(async keyPair => {
            const { publicKey, privateKey } = keyPair;
            const response = await getLiveReceiver(publicKey);
            const password = await decryptData(privateKey, response.password);
            const credients = {...response, password}
            // console.log(credients)
            call.setCredentials(credients)
        });

        pubsub.on('call_started', () => navigate("/call"))
        pubsub.on('call_ended', () => navigate("/message"))
    })
    
</script>

<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="flex flex-col">
            <div class="contact">
                {#if stages[stage] === stages[0]}
                <div class="flex flex-col justify-center items-center mt-16 mb-8 px-16 text-center secondary-text-color">
                    <strong class="text-sm primary-text-color">You are a click away from assistance</strong>
                    <span class="secondary-text-color">
                        Click on the button to talk to someone on our team
                    </span>
                    <small class="error">{ errors.message || ""}</small>
                </div>
                {/if}
                {#if stages[stage] === stages[1]}
                <div class="flex flex-col w-full text-3xl py-16 px-6 secondary-text-color font-bold mt-4">
                    Please hold on. 
                    <strong class="primary-text-color">
                        Connecting you to our team...
                    </strong>
                </div>
                {/if}
                {#if stages[stage] === stages[2]}
                <div class="relative shadow-2xl shadow-blue-200/50 border rounded-md mx-8 my-16 px-4 py-6 secondary-text-color">
                    <span>
                        While we connect you, kindly share your name with us?
                    </span>
                    <div class="flex mt-4">
                        <input
                            placeholder="Enter your name"
                            bind:value={contact.name}
                            class="border-0 border-b border-black mr-2 px-2 py-1 text-sm primary-text-color"
                            type="text"
                            on:change={handleChange}
                        />
                        <ButtonRounded
                            disabled={false}
                            on:click={processName}
                            size=8
                            title=""
                            icon="right-arrow"
                            iconColor="#30A059"
                            iconSize=16
                            className="call-btn-bg-color w-10 h-8"
                        />
                    </div>
                    {#if errors.name}
                        <small class="error text-danger">{ errors.name }</small>
                    {/if}
                </div>
                {/if}
                {#if stages[stage] === stages[3]}
                <div class="flex flex-col w-full text-3xl py-16 px-6 secondary-text-color font-bold mt-4">
                    Thank you! 
                    <strong class="primary-text-color">
                        Ringing our support team...
                    </strong>
                </div>
                {/if}
                {#if stages[stage] === stages[4]}
                <div class="relative shadow-2xl shadow-blue-200/50 border rounded-md mx-8 my-16 px-4 py-6">
                    <span>
                        Enter your phone number to enable call back
                    </span>
                    <div class="flex mt-4">
                        <input
                            placeholder="Phone Number"
                            bind:value={contact.mobile}
                            required
                            disabled={disabled}
                            class="border-0 border-b border-black mr-2 px-2 py-1 text-sm primary-text-color"
                        />
                        <ButtonRounded
                            disabled={false}
                            on:click={processPhone}
                            size=8
                            title=""
                            icon="right-arrow"
                            iconColor="#30A059"
                            iconSize=16
                            className="call-btn-bg-color w-10 h-8"
                        />
                    </div>
                    {#if errors.mobile}
                        <small class="error">{ errors.mobile }</small>
                    {/if}
                </div>
                {/if}
                {#if event !== ""}
                <div class="flex mx-4 primary-text-color">
                    <span class={`${event === "loading" ? "animate-spin" : ""} mx-2`}>
                        <Icon icon={event} size={24} color="#30A059" />
                    </span>
                    <span class="mx-2 animate-flicker" transition:fade>
                        {#if event === "loading"}
                            Connecting...
                        {:else if stages[stage] === stages[4]}
                            {#if disabled}
                                Connecting...
                            {:else}
                                Waiting...
                            {/if}
                        {:else}
                            Ringing...
                        {/if}
                    </span>
                </div>
                {/if}
            </div>
            {#if stages[stage] === stages[0]}
            <div class="w-full flex items-center justify-center">
                <!-- <ButtonRounded
                    disabled={false}
                    on:click={() => chat()}
                    size="16"
                    title="chat with us"
                    icon="add-note"
                    iconColor="#30A059"
                    iconSize=30
                    className="call-btn-bg-color w-16 h-16"
                /> -->

                <ButtonRounded
                    disabled={false}
                    on:click={initCall}
                    size="16"
                    title=""
                    icon="start-call"
                    iconColor="#30A059"
                    iconSize=30
                    className="call-btn-bg-color w-16 h-16"
                />
            </div>
            <div class="secondary-text-color w-full text-center px-8 text-xs mt-4">
                By dialling, you consent to Prime Pay collecting, processing, 
                and storing my information in accordance with our 
                <stong class="primary-bg-text-color">Privacy Policies.</stong>
            </div>
            {/if}
        </div>
    </div>
    <audio id="remoteAudio" />
</div>

<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .primary-bg-text-color {
        color: var(--primary-bg-color)
    }
    .secondary-bg-text-color {
        color: var(--secondary-bg-color)
    }
    .error {
        color: #f00;
    }
</style>